module.exports = __webpack_public_path__ + "img/facilityManagement.7831c5fd.png";